import { ga4Push } from '../../../ga4/ga4-utilities';
import AbstractValidator from '../abstract-validator';
import AbstractValidatorOptions from '../abstract-validator-options';
import Localization from '../../../other/localization';
import { GrecaptchaV2 } from '../../../other/grecaptcha/grecaptcha-v2';

/**
 * Registration form validation module
 *
 * @author Kovács Tamás
 * @returns Registration form validation module
 */
function RegistrationForm() {
    const formId = 'registrationForm';
    const validator = AbstractValidator(formId);
    const validatorOptions = AbstractValidatorOptions();
    const localization = new Localization();
    const greCaptchaV2 = new GrecaptchaV2();
    const reCaptchaErrorElement = $('#registrationCaptchaError');

    function init(
        openModal,
    ) {
        validatorOptions.focusInvalid = false;
        validatorOptions.showToastMessagesOnError = false;
        validatorOptions.scrollToFirstError = false;
        validatorOptions.messages = {
            first_name: {
                required: localization.getMessage('validation_first_name_required'),
            },
            last_name: {
                required: localization.getMessage('validation_last_name_required'),
            },
            email: {
                required: localization.getMessage('validation-message-email-required'),
            },
        };
        validatorOptions.scrollToFirstError = false;

        validator.init(
            {
                first_name: {
                    maxlength: 60,
                    required: true,
                },
                last_name: {
                    maxlength: 60,
                    required: true,
                },
                email: {
                    maxlength: 60,
                    required: true,
                    customEmail: true,
                },
            },
            validatorOptions,
        );

        greCaptchaV2.init('registrationCaptcha');
        greCaptchaV2.setErrorContainer(reCaptchaErrorElement);

        $(`#${formId}`)
        .on('success', (event) => {
            const currentForm = $(event.currentTarget);
            const callback = currentForm.attr('data-modal-callback');
            const redirect = currentForm.attr('data-redirect');

            if (typeof redirect !== 'undefined') {
                window.location = redirect;
            }

            if (callback) {
                openModal(callback);
            }

            ga4Push({
                event: 'registerSuccessful',
            });

            currentForm
            .closest('.modal')
            .modal('hide');

            window.location.reload();
        })
        .on(
            'hidden.bs.modal',
            () => validator.resetForm(),
        )
        .on('error', (event, errors) => {
            greCaptchaV2.reset();
            if (Object.keys(errors).indexOf('g-recaptcha-response') > -1) {
                reCaptchaErrorElement.html(Object.values(errors)[0]);
            }
        })
        .on('invalidForm', () => {
            greCaptchaV2.reset();
        });
    }

    return {
        init,
    };
}

export default RegistrationForm;
